import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useColetaPrecosListaFilters
 */

type State = {
  dataRequisicaoStart: Date | null;
  dataRequisicaoEnd: Date | null;
  fornecedor: number[] | null;
  requisicao: number[] | null;
  produtoServico: number[] | null;
  centroCusto: number[] | null;
  nroColeta: string | null;
  ordemCompra: number[] | null;
  status: number;
};

export const initialColetaPrecosListaFilters: State = {
  dataRequisicaoStart: null,
  dataRequisicaoEnd: null,
  fornecedor: null,
  requisicao: null,
  produtoServico: null,
  centroCusto: null,
  nroColeta: null,
  ordemCompra: null,
  status: 5,
}

export const useColetaPrecosListaFilters = create<State>((set) => ({
  ...initialColetaPrecosListaFilters,
}));